import React from 'react'

import { FaUserCircle } from 'react-icons/fa';

interface Props {
    shouldHide?: Function
    onClickCreateOrder: Function
    onClickDeleteOrder: Function
    onClickMyMolo: Function
    onClickOrderHistory: Function
    onClickProfile: Function
    onClickProductDownload: Function
    logoutUser: Function
    hideDelete?: boolean
    editMode?: boolean
    deleteOrderText?: string
    showProductDownload?: boolean
    orderActivityToggleEnabled?: boolean
    orderActivityVisible?: boolean
    onOrderActivityToggle?: () => void
}

const ShopDropDown: React.FC<Props> = (props) => {
    const {
        onClickCreateOrder,
        onClickDeleteOrder,
        shouldHide,
        hideDelete,
        logoutUser,
        onClickMyMolo,
        onClickOrderHistory,
        onClickProfile,
        onClickProductDownload,
        showProductDownload,
        orderActivityToggleEnabled = false,
        orderActivityVisible,
        onOrderActivityToggle,
    } = props;
    const node = React.useRef(null);
    const [open, setValue] = React.useState(false);
    const [localActivityVisible, setLocalActivityVisible] = React.useState(!!orderActivityVisible);

    React.useEffect(() => {
        if (!orderActivityToggleEnabled) {
            setLocalActivityVisible(false);
            return;
        }

        setLocalActivityVisible(!!orderActivityVisible);
    }, [orderActivityVisible, orderActivityToggleEnabled]);

    const handleOnClickCreateOrder = () => {
        if (shouldHide) {
            shouldHide();
        }

        onClickCreateOrder();
    }

    React.useEffect(() => {
        // add when mounted
        document.addEventListener("mousedown", handleClickOutside);
        // return function to be called when unmounted
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    });

    const handleClickOutside = (e: any) => {
        // @ts-ignore
        if(node.current.contains(e.target)) {
            return;
        }
        
        // outside click 
        setValue(false)
    };

    const handleToggle = () => {
        setValue(!open)
    }

    return (
        <div className="dropdown" ref={node}>
            <div className="dropdown__trigger my-molo-dropdown-trigger" onClick={handleToggle}>
                
                <span className="desktop-only">
                    My Molo
                </span>
                <FaUserCircle className="my-molo-dropdown-icon" />
            </div>
            <div className={"dropdown__menu dropdown__menu--my-molo " + (open ? "--is-active" : "--is-hidden")}>
                <div
                    className={"dropdown__menu__item"}
                    onClick={() => {
                        setValue(false)
                        handleOnClickCreateOrder()}
                    }
                >
                    Create new order
                </div>
                {
                    !hideDelete &&
                    <div
                        className={"dropdown__menu__item"}
                        onClick={() => {
                            setValue(false)
                            onClickDeleteOrder()}
                        }
                    >
                        { props.deleteOrderText ? props.deleteOrderText : 'Delete current order'} 
                    </div>
                }
                <div
                    className={"dropdown__menu__item"}
                    onClick={() => {
                        setValue(false)
                        onClickMyMolo()}
                    }
                >
                    My orders
                </div>
                <div
                    className={
                        'dropdown__menu__item dropdown__menu__item--toggle' +
                        (orderActivityToggleEnabled ? '' : ' dropdown__menu__item--toggle-disabled')
                    }
                    role="menuitemcheckbox"
                    aria-checked={orderActivityToggleEnabled ? localActivityVisible : false}
                    aria-disabled={!orderActivityToggleEnabled}
                    title={
                        orderActivityToggleEnabled
                            ? undefined
                            : 'Open an editable order to enable order activity'
                    }
                    onClick={(event) => {
                        if (!orderActivityToggleEnabled || !onOrderActivityToggle) {
                            return;
                        }

                        event.preventDefault();
                        event.stopPropagation();
                        const next = !localActivityVisible;
                        setLocalActivityVisible(next);
                        onOrderActivityToggle();
                    }}
                >
                    <span className="dropdown__menu__item__toggle-label">Order activity</span>
                    <span
                        className={
                            'dropdown__menu__toggle' +
                            (localActivityVisible && orderActivityToggleEnabled
                                ? ' dropdown__menu__toggle--on'
                                : '')
                        }
                        aria-hidden
                    />
                </div>
                <div
                    className={"dropdown__menu__item"}
                    onClick={() => {
                        setValue(false)
                        onClickOrderHistory()}
                    }
                >
                    Activity history
                </div>
                {showProductDownload && <div
                    className={"dropdown__menu__item"}
                    onClick={() => {
                        setValue(false)
                        onClickProductDownload()}
                    }
                >
                    Image download
                </div>}
                <div
                    className={"dropdown__menu__item"}
                    onClick={() => {
                        setValue(false)
                        onClickProfile()}
                    }
                >
                    My profile
                </div>
                <div
                    className={"dropdown__menu__item"}
                    onClick={() => {
                        setValue(false)
                        logoutUser()
                    }}
                >
                    Logout
                </div>
            </div>
        </div>
    )
}

export default ShopDropDown;